import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "role-page" }
const _hoisted_2 = { class: "role-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "role-title-bar" }
const _hoisted_5 = { class: "role-main" }
const _hoisted_6 = { class: "role-list-panel" }
const _hoisted_7 = { class: "role-list-content" }
const _hoisted_8 = { class: "role-list-pagination" }
const _hoisted_9 = { class: "role-detail-panel" }
const _hoisted_10 = { class: "permission-panel" }
const _hoisted_11 = { class: "permission-groups" }
const _hoisted_12 = { class: "permission-table" }

import { ref } from 'vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

interface PermissionGroup {
  name: string
  code: string
  children?: Permission[]
}

interface Permission {
  name: string
  code: string
  description?: string
  status?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleManager',
  setup(__props) {

const permissionList = ref([
  {
    name: '基础',
    code: 'group1',
    children: [
      { name: '通知配置', code: 'group1', status: '默认开通' },
      { name: '查询通知配置', code: 'systemNotifyConfigFind', status: '申请权限' },
      { name: '删除通知配置', code: 'systemNotifyConfigDelete', status: '申请权限' },
      { name: '修改通知配置', code: 'systemNotifyConfigModify', status: '申请权限' },
      { name: '新增通知配置', code: 'systemNotifyConfigAdd', status: '申请权限' }
    ]
  },
  {
    name: '运营管理',
    code: 'group2',
    children: [
      { name: '运营管理', code: 'group2', status: '默认开通' },
      { name: '新增工单管理', code: 'systemOpsWorkOrderAdd', status: '默认开通' },
      { name: '修改帮助与反馈', code: 'systemOpsFeedbackModify', status: '默认开通' },
      { name: '查询帮助与反馈', code: 'systemOpsFeedbackFind', status: '默认开通' },
      { name: '修改工单管理', code: 'systemOpsWorkOrderModify', status: '申请权限' }
    ]
  }
])
const tabKey = ref('info')
const roleList = ref([
  { name: '普通用户', selected: true },
  { name: '超级管理员', selected: false }
])
function selectRole(item: any) {
  roleList.value.forEach(r => (r.selected = false))
  item.selected = true
}
const columns = [
  { title: '角色名称', dataIndex: 'name', key: 'name' },
  { title: '管理员', dataIndex: 'admin', key: 'admin' },
  { title: '角色编码', dataIndex: 'code', key: 'code' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', key: 'action' }
]
const roleInfoData = [
  { name: '管理员', admin: 'admin', code: 'admin', createdAt: '2025-05-02 11:33' }
]
const activeGroup = ref('group1')
const selectedPerms = ref<string[]>([])
const permGroups = ref([
  { name: '基础', code: 'group1' },
  { name: '运营管理', code: 'group2' }
])

const permColumns = [
  { title: '权限名称', dataIndex: 'name', key: 'name' },
  { title: '权限编码', dataIndex: 'code', key: 'code' },
  { title: '操作', key: 'status' }
]

function handleGroupSelect(code: string) {
  activeGroup.value = code
}

function onPermChange(selectedRowKeys: string[]) {
  selectedPerms.value = selectedRowKeys
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, { type: "primary" }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("+ 新增角色")
                ])),
                _: 1
              }),
              _createVNode(_component_a_input, {
                placeholder: "请输入角色名称查询",
                style: {"width":"220px","margin-left":"16px"}
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                style: {"margin-left":"8px"}
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("查询")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "role-list-title" }, "角色列表", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_a_list, {
                    "data-source": roleList.value,
                    pagination: false,
                    style: {"background":"#fff"}
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createVNode(_component_a_list_item, {
                        class: _normalizeClass({selected: item.selected}),
                        onClick: ($event: any) => (selectRole(item)),
                        style: {"padding":"12px 16px","cursor":"pointer","border-left":"2px solid transparent"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_pagination, {
                    total: 2,
                    pageSize: 1,
                    current: 1,
                    size: "small"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_tabs, {
                  activeKey: tabKey.value,
                  "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event)),
                  class: "role-tabs-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "info",
                      tab: "角色信息"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: columns,
                          "data-source": roleInfoData,
                          pagination: false,
                          size: "middle",
                          bordered: ""
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.key === 'action')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_a_button, {
                                    type: "default",
                                    size: "small",
                                    style: {"margin-right":"8px"}
                                  }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                      _createTextVNode("编辑角色信息")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_button, {
                                    type: "danger",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                      _createTextVNode("删除角色")
                                    ])),
                                    _: 1
                                  })
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "perm",
                      tab: "权限授权"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "group-title" }, "授权分组", -1)),
                            _createVNode(_component_a_list, {
                              "data-source": permGroups.value,
                              pagination: false,
                              size: "small"
                            }, {
                              renderItem: _withCtx(({ item }) => [
                                _createVNode(_component_a_list_item, {
                                  class: _normalizeClass({active: item.code === activeGroup.value}),
                                  onClick: ($event: any) => (handleGroupSelect(item.code)),
                                  style: {"padding":"8px 16px","cursor":"pointer"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClick"])
                              ]),
                              _: 1
                            }, 8, ["data-source"])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_a_table, {
                              columns: permColumns,
                              "data-source": permissionList.value,
                              pagination: false,
                              size: "middle",
                              "row-selection": { selectedRowKeys: selectedPerms.value, onChange: onPermChange }
                            }, {
                              bodyCell: _withCtx(({ column, record }) => [
                                (column.key === 'status')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (record.status === '默认开通')
                                        ? (_openBlock(), _createBlock(_component_a_tag, {
                                            key: 0,
                                            color: "blue"
                                          }, {
                                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                              _createTextVNode("默认开通")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_a_button, {
                                            key: 1,
                                            type: "primary",
                                            size: "small",
                                            ghost: ""
                                          }, {
                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                              _createTextVNode("申请权限")
                                            ])),
                                            _: 1
                                          }))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["data-source", "row-selection"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "app",
                      tab: "应用授权"
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("div", { style: {"height":"80px"} }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})